import { getWithToken, postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";
const structure_template_sharing = apiUrl + "/structure_template_sharing";
const routes = {
  label: "Structure Template Sharing",
  root: structure_template_sharing,
  get_by_company_id: structure_template_sharing + "/get_by_company_id",
  new: structure_template_sharing + "/new",
  delete: structure_template_sharing + "/delete",
};
export const StructureTemplateSharing = {
  label: routes.label,
  get_by_company_id: (company_id) => getWithToken(routes.get_by_company_id, { company_id }),
  /**
   *
   * @param {[{company_id: number, structure_id: string}]} structure_template_sharings
   * @returns
   */
  new: (structure_template_sharings) => postWithToken(routes.new, structure_template_sharings),
  /**
   *
   * @param {[{company_id: number, structure_id: string}]} structure_template_sharings
   * @returns
   */
  delete: (structure_template_sharings) => postWithToken(routes.delete, structure_template_sharings),
};
